// src/pages/MediaOutreach/MediaOutreach.jsx
import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Breadcrumb from "../../components/Breadcrumb";
import MediaOutreachMain from "./MediaOutreachMain";
import ScrollToTop from "../../components/ScrollTop";

import Logo from "../../assets/images/logos/logo2.png";

const MediaOutreach = () => {
  return (
    <body className="media-outreach-page">
      <Header
        parentMenu="mediaOutreach"
        topbarEnable="enable"
        headerNormalLogo={Logo}
        headerStickyLogo={Logo}
      />

      <div className="react-wrapper">
        <div className="react-wrapper-inner">
          {/* <Breadcrumb pageTitle="Media & Outreach" /> */}

          <MediaOutreachMain />

          <ScrollToTop />
        </div>
      </div>

      <Footer />
    </body>
  );
};

export default MediaOutreach;
